import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-feedback',
  templateUrl: './reports-feedback.component.html',
  styleUrl: './reports-feedback.component.scss'
})
export class ReportsFeedbackComponent {
  constructor(
    ){}

  ngOnInit(): void {
  }
}
